module.exports = __webpack_public_path__ + "img/extended.5951fcf4.png";